import { useApplication } from "./application";
import { useApplicationPageMutation } from "./aggregatedData";
/**
 * @deprecated This hook is being replaced with the version in `applicationActions.ts`
 * as part of the application page revamp project. Please use that instead.
 */
export function useLegacySendApplicationAction() {
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationPageMu = useApplicationPageMutation(function (_ref) {
      var actionId = _ref.actionId,
        actionData = _ref.actionData;
      return {
        method: 'POST',
        url: "/applications/".concat(application.id, "/actions"),
        body: {
          data: {
            type: 'application_action',
            attributes: {
              actionId: actionId,
              actionData: actionData
            }
          }
        }
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    isLoading = _useApplicationPageMu.isLoading;
  return {
    sendApplicationAction: mutate,
    isSendingApplicationAction: isLoading
  };
}